import { isValidWorkflowName } from "../../../utils/workflowDefinition/workflowDefinitionUtils";
export const navigateWorkflowTaskLink = {
    // Simple, clean URLs for normal navigation
    toTaskDefinition: (taskName) => {
        return `/taskDef/${encodeURIComponent(taskName)}`;
    },

    // Specifically for workflow context (your use case)
    toTaskDefinitionFromWorkflow: (taskName, workflowName) => {
        const baseUrl = `/taskDef/${encodeURIComponent(taskName)}`;
        const params = new URLSearchParams({
            loadedFrom: 'workflowDefinition' // Always include this
        });

        // Only add workflowName if it's valid
        if (workflowName &&
            workflowName !== 'undefined' &&
            workflowName !== 'null' &&
            workflowName.trim() !== '') {
            params.set('workflowName', workflowName.trim());
        }

        return `${baseUrl}?${params}`;
    },

    parseContext: (searchParams) => {
        const loadedFrom = searchParams.get('loadedFrom');
        const workflowName = searchParams.get('workflowName');

        // Clean workflowName - return null if invalid
        // const workflowName = isValidWorkflowName(workflowNameRaw)

        return { loadedFrom, workflowName };
    }
};